var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cashDepositAtKiosk
    ? _c("div", { staticClass: "kiosk_cash_deposit" }, [
        _c("div", { staticClass: "kiosk_cash_deposit_holder" }, [
          _c("h1", { staticClass: "text_aligncenter" }, [
            _vm._v(_vm._s(_vm.$t("MyAccount.DepositAtKiosk")))
          ]),
          _vm._v(" "),
          _vm.generatingTokenInProgress
            ? _c("div", [_c("circle-loader")], 1)
            : _vm._e(),
          _vm._v(" "),
          !_vm.generatingTokenInProgress
            ? _c(
                "div",
                { staticClass: "get_token_holder" },
                [
                  _vm.depositToken
                    ? [
                        _c("div", { staticClass: "auth_code_title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("MyAccount.DepositAtKiosk.AuthCode"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "token" }, [
                          _vm._v(_vm._s(_vm.depositToken))
                        ]),
                        _vm._v(" "),
                        _vm.countDown && _vm.countDown > 0
                          ? _c("div", { staticClass: "countDownHolder" }, [
                              _c("span", { staticClass: "expires_in" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MyAccount.DepositAtKiosk.ExpiresIN")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm.countDown === 60
                                ? _c("div", { staticClass: "counter" }, [
                                    _vm._v("01:00")
                                  ])
                                : _vm.countDown < 10
                                ? _c("div", { staticClass: "counter" }, [
                                    _vm._v("00:0" + _vm._s(_vm.countDown))
                                  ])
                                : _c("div", { staticClass: "counter" }, [
                                    _vm._v("00:" + _vm._s(_vm.countDown))
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "auth_code_desc" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("MyAccount.DepositAtKiosk.AuthCodeDesc")
                            )
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.depositToken
                    ? [
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary-btn",
                            on: {
                              click: function($event) {
                                return _vm.getToken()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MyAccount.DepositAtKiosk.GetToken")
                              )
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15ca0d4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ca0d4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/DepositAtKiosk.vue
// module id = null
// module chunks = 